"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var AttachmentBookIcon = function AttachmentBookIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.85,3.67H6.65A1.7,1.7,0,0,0,5,5.37V19a1.7,1.7,0,0,0,1.7,1.7h10.2a1.7,1.7,0,0,0,1.7-1.7V5.37A1.71,1.71,0,0,0,16.85,3.67ZM6.65,5.37H10.9v6.8L8.77,10.9,6.65,12.17Z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    fill: "none"
  }));
};
var _default = exports["default"] = AttachmentBookIcon;
//# sourceMappingURL=AttachmentBook.js.map